import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './ForgotPassword.module.css';
import { forgotPassword } from '../services/apiUsers.ts';

export const SignInFormPass = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      // Call the actual forgot password API
      await forgotPassword(email);
      
      // Set submitted state to show success message
      setIsSubmitted(true);
      
    } catch (err) {
      console.error('Password reset request error:', err);
      
      // Handle different error scenarios
      if (err.response?.status === 404) {
        setError('No account found with this email address.');
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.formHeader}>
          <h1>Forgot Password</h1>
          <p>Enter your email to reset your password</p>
        </div>
        
        {error && <div className={styles.errorMessage}>{error}</div>}
        
        {isSubmitted ? (
          <div className={styles.successMessage}>
            <p>Password reset instructions have been sent to your email.</p>
            <p>Please check your inbox and follow the instructions to reset your password.</p>
            <div className={styles.linkContainer}>
              <Link to="/sign-in" className={styles.backLink}>Back to Sign In</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            
            <button 
              type="submit" 
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Reset Password'}
            </button>
            
            <div className={styles.linkContainer}>
              <Link to="/sign-in" className={styles.backLink}>Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
